import React, { createContext, useContext } from "react";
import { useQuery } from "react-query";
import Cookies from "js-cookie";

import { routesName } from "@lib/RoutesName/Routes";
import { User } from "@lib/Types";
import { useUser } from "@lib/Hooks/requests/useUser";


interface UserContextType {
  user:  User | undefined
  isLoading: boolean;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: user, isLoading } = useUser()
  return (
    <UserContext.Provider value={{ user, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
};